var map, marker, returnData;

export default class GoogleMapsApi {
  getGeocoderInstance = async (retries = 10) => {
    for (let i = 0; i < retries; i++) {
        if (typeof google !== "undefined" && google.maps && google.maps.Geocoder) {
            return new google.maps.Geocoder();
        }
        if (typeof google !== "undefined" && google.maps && google.maps.importLibrary) {
            const { Geocoder } = await google.maps.importLibrary("geocoding");
            return new Geocoder();
        }
        console.log(`Locaso: Waiting for Google Maps Geocoder... (attempt ${i + 1})`);
        await new Promise(resolve => setTimeout(resolve, 500));
    }
    throw new Error("Google Maps Geocoder is not available after retries");
  };

  initModal = async (id) => {
    var location = new google.maps.LatLng(0, 0);

    var mapProperty = {
      center: location,
      zoom: 18,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    var map = new google.maps.Map(
      document.getElementById(`${id}`),
      mapProperty,
    );

    var places;
    var searchBox = new google.maps.places.SearchBox(
      document.getElementById(`${id}-input`),
    );

    google.maps.event.addListener(searchBox, "places_changed", () => {
      searchBox.set("map", null);
      places = searchBox.getPlaces();

      marker.setMap(null);
      marker = new google.maps.Marker({
        map: map,
        draggable: true,
        animation: google.maps.Animation.DROP,
        position: places[0].geometry.location,
      });

      this.geocodePosition(marker.getPosition());

      google.maps.event.addListener(marker, "dragend", () => {
        map.setCenter(marker.getPosition());
        this.geocodePosition(marker.getPosition());
      });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          let pos = {
            lat: places[0].geometry.location.lat(),
            lng: places[0].geometry.location.lng(),
          };
          marker.setPosition(pos);
          map.setCenter(marker.getPosition());
          this.geocodePosition(marker.getPosition());
        });
      }
    });

    marker = new google.maps.Marker({
      map: map,
      draggable: true,
      animation: google.maps.Animation.DROP,
      position: location,
    });
    marker.setMap(map);

    this.geocodePosition(marker.getPosition());

    google.maps.event.addListener(marker, "dragend", () => {
      map.setCenter(marker.getPosition());
      this.geocodePosition(marker.getPosition());
    });

    returnData = await this.navigatorGeolocation(map);
    return returnData;
  };

  editAddress = async (id, lat, lon) => {
    var location = new google.maps.LatLng(lat, lon);

    var mapProperty = {
      center: location,
      zoom: 18,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    var map = new google.maps.Map(
      document.getElementById(`${id}`),
      mapProperty,
    );

    var places;
    var searchBox = new google.maps.places.SearchBox(
      document.getElementById(`${id}-input`),
    );

    google.maps.event.addListener(searchBox, "places_changed", () => {
      searchBox.set("map", null);
      places = searchBox.getPlaces();

      marker.setMap(null);
      marker = new google.maps.Marker({
        map: map,
        draggable: true,
        animation: google.maps.Animation.DROP,
        position: places[0].geometry.location,
      });

      google.maps.event.addListener(marker, "dragend", () => {
        map.setCenter(marker.getPosition());
        this.geocodePosition(marker.getPosition());
      });

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          let pos = {
            lat: places[0].geometry.location.lat(),
            lng: places[0].geometry.location.lng(),
          };
          marker.setPosition(pos);
          map.setCenter(marker.getPosition());
          this.geocodePosition(marker.getPosition());
        });
      }
    });

    marker = new google.maps.Marker({
      map: map,
      draggable: true,
      animation: google.maps.Animation.DROP,
      position: location,
    });
    marker.setMap(map);

    this.geocodePosition(marker.getPosition());

    google.maps.event.addListener(marker, "dragend", () => {
      map.setCenter(marker.getPosition());
      this.geocodePosition(marker.getPosition());
    });
  };

  navigatorGeolocation = (map) => {
    return new Promise((resolve) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          let pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          marker.setPosition(pos);
          map.setCenter(marker.getPosition());
          resolve(await this.geocodePosition(marker.getPosition()));
        });
      } else {
          resolve(null);
      }
    });
  };

  geocodePosition = (pos) => {
    return new Promise(async (resolve, reject) => {
      var addressDetails = { ...pos };
      var geocoder = await this.getGeocoderInstance();
      geocoder.geocode(
        {
          latLng: { lat: parseFloat(pos.lat), lng: parseFloat(pos.lng) },
        },
        (results, status) => {
          if (status == google.maps.GeocoderStatus.OK) {
            results.forEach((element) => {
              if (element.geometry.location_type == "ROOFTOP" && !Object.hasOwn(addressDetails, "ROOFTOP")) {
                addressDetails.ROOFTOP = element;
              }
              if (element.geometry.location_type == "GEOMETRIC_CENTER" && !Object.hasOwn(addressDetails, "GEOMETRIC_CENTER")) {
                addressDetails.GEOMETRIC_CENTER = element;
              }
              if (element.geometry.location_type == "APPROXIMATE" && !Object.hasOwn(addressDetails, "APPROXIMATE")) {
                addressDetails.APPROXIMATE = element;
              }
            });
            addressDetails.msgCode = 1;
            addressDetails.msgStatus = "SUCCESS";

            let roofTopAddressDetails, roofTopAddress;
            if (Object.hasOwn(addressDetails, "ROOFTOP")) {
              roofTopAddressDetails = addressDetails.ROOFTOP.address_components;
              roofTopAddress = addressDetails.ROOFTOP;
            } else if (Object.hasOwn(addressDetails, "GEOMETRIC_CENTER")) {
              roofTopAddressDetails = addressDetails.GEOMETRIC_CENTER.address_components;
              roofTopAddress = addressDetails.GEOMETRIC_CENTER;
            } else {
              roofTopAddressDetails = addressDetails.APPROXIMATE.address_components;
              roofTopAddress = addressDetails.APPROXIMATE;
            }

            $(".inputAddress").val(roofTopAddress.formatted_address);
            $(".inputLat").val(pos.lat);
            $(".inputLon").val(pos.lng);

            roofTopAddressDetails.forEach((item) => {
              if (item.types.includes("plus_code")) $(".inputAddressshort").val(item.long_name);
              if (item.types.includes("locality")) $(".inputCity").val(item.long_name);
              if (item.types.includes("administrative_area_level_1")) $(".inputState").val(item.long_name);
              if (item.types.includes("postal_code")) $(".inputPincode").val(item.long_name);
            });

            resolve(addressDetails);
          } else {
            addressDetails.msgCode = 0;
            addressDetails.msgStatus = "FAILURE";
            reject(addressDetails);
          }
        },
      );
    });
  };

  navigatorGeolocationForCurrentLocation = () => {
    return new Promise((resolve) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            let pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            resolve(await this.geocodeCurrentPosition(pos));
          },
          (error) => {
            resolve({
              lat: 15.494295,
              lng: 73.827209,
              msgCode: 0,
              msgStatus: "FAIL",
            });
          },
        );
      } else {
        resolve({
          lat: 15.494295,
          lng: 73.827209,
          msgCode: 0,
          msgStatus: "GEOLOCATION_UNAVAILABLE",
        });
      }
    });
  };

  geocodeCurrentPosition = (pos) => {
    return new Promise(async (resolve, reject) => {
      var addressDetails = { ...pos };
      var geocoder = await this.getGeocoderInstance();
      geocoder.geocode(
        {
          latLng: { lat: parseFloat(pos.lat), lng: parseFloat(pos.lng) },
        },
        function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            results.forEach((element) => {
              if (element.geometry.location_type == "ROOFTOP" && !Object.hasOwn(addressDetails, "ROOFTOP")) {
                addressDetails.ROOFTOP = element;
              }
              if (element.geometry.location_type == "GEOMETRIC_CENTER" && !Object.hasOwn(addressDetails, "GEOMETRIC_CENTER")) {
                addressDetails.GEOMETRIC_CENTER = element;
              }
              if (element.geometry.location_type == "APPROXIMATE" && !Object.hasOwn(addressDetails, "APPROXIMATE")) {
                addressDetails.APPROXIMATE = element;
              }
            });
            addressDetails.msgCode = 1;
            addressDetails.msgStatus = "SUCCESS";
            resolve(addressDetails);
          } else {
            addressDetails.msgCode = 0;
            addressDetails.msgStatus = "FAILURE";
            resolve(addressDetails);
          }
        },
      );
    });
  };

  geocodeFindPosition = (latitude, longitude) => {
    var findPostiton = {
      lat: latitude,
      lng: longitude,
    };
    return new Promise(async (resolve, reject) => {
      var addressDetails = { ...findPostiton };
      var geocoder = await this.getGeocoderInstance();
      geocoder.geocode(
        {
          latLng: { lat: parseFloat(findPostiton.lat), lng: parseFloat(findPostiton.lng) },
        },
        function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            results.forEach((element) => {
              if (element.geometry.location_type == "ROOFTOP" && !Object.hasOwn(addressDetails, "ROOFTOP")) {
                addressDetails.ROOFTOP = element;
              }
              if (element.geometry.location_type == "GEOMETRIC_CENTER" && !Object.hasOwn(addressDetails, "GEOMETRIC_CENTER")) {
                addressDetails.GEOMETRIC_CENTER = element;
              }
              if (element.geometry.location_type == "APPROXIMATE" && !Object.hasOwn(addressDetails, "APPROXIMATE")) {
                addressDetails.APPROXIMATE = element;
              }
            });
            addressDetails.msgCode = 1;
            addressDetails.msgStatus = "SUCCESS";
            resolve(addressDetails);
          } else {
            addressDetails.msgCode = 0;
            addressDetails.msgStatus = "FAILURE";
            resolve(addressDetails);
          }
        },
      );
    });
  };

  initMarketMap = async (mapDivID, vendorData) => {
    const positionGoa = { lat: 15.2993, lng: 74.124 };
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

    let marketMap = new Map(document.getElementById(`${mapDivID}`), {
      zoom: 9,
      center: positionGoa,
      mapId: "Market_MAP_ID",
    });
    let vendorsMarkersArray = [
      { lat: 15.2993, lng: 74.124, title: "Test Vendor 1" },
      { lat: 15.1993, lng: 74.024, title: "Test Vendor 2" },
    ];

    vendorsMarkersArray = vendorData ? vendorData : vendorsMarkersArray;

    vendorsMarkersArray.forEach(({ title, lat, lng }, i) => {
      lat = parseFloat(lat);
      lng = parseFloat(lng);

      const pin = new PinElement({});
      const markerAdv = new AdvancedMarkerElement({
        position: { lat, lng },
        map: marketMap,
        title: `${title}`,
        content: pin.element,
      });
      marketMap.setCenter({ lat, lng });
      if (vendorData.length == 1) {
        marketMap.setZoom(12);
      } else {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position) => {
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            marketMap.setCenter({ lat, lng });
            marketMap.setZoom(12);
          });
        }
      }
    });
  };

  getVendorMarketMap = (mapID, vendor_ID, vendor_Data) => {
    if (!mapID) return false;
    if (vendor_Data) {
      this.initMarketMap(mapID, vendor_Data);
    } else {
      $.ajax({
        url: baseURL + "api/customer/Homepage/getVendorMarker",
        type: "GET",
        headers: { Authorization: X_API_KEY },
        data: { vendor_ID: vendor_ID },
        success: (result) => {
          this.initMarketMap(mapID, result);
        },
        error: (result) => {
          console.error(result);
        },
      });
    }
  };

  openGMapModal = (e, categtryVendorsData) => {
    e.preventDefault();
    var vendor_ID = e.currentTarget.dataset.vendorid;
    var vendor_Data = e.currentTarget.dataset.vendorsdata;
    if (vendor_Data) {
      vendor_Data = vendor_Data.split(", ");
      vendor_Data = JSON.parse("[" + vendor_Data + "]");
    }
    if (!vendor_ID && !vendor_Data) return;

    window.$("#vendorLocationMapModal").modal("show");
    this.getVendorMarketMap("marketMapContainer", vendor_ID, vendor_Data);
    $("#vendorLocationMapModalCloseBtn").on("click", () => {
      window.$("#vendorLocationMapModal").modal("hide");
    });
  };
}
